module.exports = __webpack_public_path__ + "72ddaa893ec9b040107bafe3a0fad2f4.woff";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Bold.woff
// module id = 13
// module chunks = 0